/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Macros_AInputs */

const en_gc_resources_faq_macros_a = /** @type {(inputs: Gc_Resources_Faq_Macros_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. GridCraft does not support VBA macros. Keep macro-dependent workbooks in a tool that supports them, such as desktop Microsoft Excel.`)
};

const zh_gc_resources_faq_macros_a = /** @type {(inputs: Gc_Resources_Faq_Macros_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不能。GridCraft 不支持 VBA 宏。依赖宏的工作簿请继续使用支持 VBA 的工具，例如桌面版 Microsoft Excel。`)
};

/**
* | output |
* | --- |
* | "No. GridCraft does not support VBA macros. Keep macro-dependent workbooks in a tool that supports them, such as desktop Microsoft Excel." |
*
* @param {Gc_Resources_Faq_Macros_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_macros_a = /** @type {((inputs?: Gc_Resources_Faq_Macros_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Macros_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_macros_a(inputs)
	return zh_gc_resources_faq_macros_a(inputs)
});
export { gc_resources_faq_macros_a as "gc.resources.faq.macros.a" }